export default "__VITE_ASSET__C0bopb6q__"